import React from 'react';

import '../styles/Hero.css';
import { useTranslation } from 'react-i18next';
import { HERO_SUBTITLE, HERO_TITLE } from '../data/navbar/menu';

const Hero = () => {
  const {t} = useTranslation();
  return(
      <section class="bgimage" id="home">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div class="container heroText">
              <p class="title">{t(HERO_TITLE)}</p>
              <p class="subtitle">{t(HERO_SUBTITLE)}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
  );
}

export default Hero;